interface SkeletonProps {
  className?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}

const RADIUS: Record<Required<SkeletonProps>['rounded'], string> = {
  sm: 'rounded',
  md: 'rounded-lg',
  lg: 'rounded-card',
  full: 'rounded-full',
};

// shimmer(foundation.css) — sunken 표면 위 하이라이트 슬라이드
export function Skeleton({ className = '', rounded = 'md' }: SkeletonProps) {
  return (
    <span aria-hidden="true" className={`shimmer block ${RADIUS[rounded]} ${className}`} />
  );
}

export function SkeletonCard() {
  return (
    <div
      role="status"
      aria-label="불러오는 중"
      className="rounded-[22px] bg-surface/60 backdrop-blur-sm p-5"
    >
      <Skeleton className="h-5 w-3/4" />
      <Skeleton className="mt-2.5 h-4 w-1/2" />
      <Skeleton className="mt-4 h-20 w-full" />
    </div>
  );
}

export function SkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div role="status" aria-label="목록 불러오는 중" className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
